<template>
  <div class="block">
    <div class="block__header">
      <h2 class="block__title">{{title}}</h2>
    </div>
    <div class="block__content">
      <ul class="basket-list">
        <basket-list-item v-for="item in content.Items" :content="item"></basket-list-item>
      </ul>
    </div>
  </div>
</template>

<script>
  import BasketListItem from "./BasketListItem";

  export default {
    props: ["content", "title"],
    components: {
      BasketListItem
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .basket-list{
    @include clear-fix;
    list-style: none;
    margin: 0;
    padding: 0;
    min-height: 300px;
  }

</style>



// WEBPACK FOOTER //
// BasketList.vue?0eee418d